import { EnhancedUserProfile } from './ProfileDataService';

// Modified mock data with Spotify profiles
export const mockProfiles: EnhancedUserProfile[] = [
  {
    userId: '1',
    name: 'Alex Rivera',
    displayName: 'AlexBeats',
    bio: 'Producer and mixing engineer specializing in hip-hop and electronic music. Looking to collaborate with vocalists and songwriters.',
    role: 'Producer',
    location: 'Los Angeles, CA',
    avatarUrl: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
    genres: ['Hip-Hop', 'Electronic', 'Pop'],
    socialLinks: { instagram: 'alexbeats', spotify: 'alexbeats' },
    memberSince: new Date('2023-01-15'),
    totalReleases: 12,
    totalStreams: 45000,
    followers: 520,
    following: 230,
    matchScore: {
      score: 92,
      factors: {
        genreOverlap: 95,
        roleCompatibility: 90,
        popularityMatch: 85,
        locationProximity: 100
      }
    },
    spotifyProfile: {
      spotifyId: 'alexbeats123',
      monthlyListeners: 15000,
      popularity: 65,
      topTracks: [
        {
          id: 'track1',
          name: 'Late Night Vibes',
          artists: ['AlexBeats', 'MC Flow'],
          imageUrl: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
          popularity: 75,
          durationMs: 180000,
          soundcloudUrl: 'https://soundcloud.com/alexbeats/late-night-vibes'
        },
        {
          id: 'track2',
          name: 'Urban Sunrise',
          artists: ['AlexBeats'],
          imageUrl: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
          popularity: 68,
          durationMs: 210000,
          youtubeId: 'dQw4w9WgXcQ',
          soundcloudUrl: 'https://soundcloud.com/alexbeats/urban-sunrise'
        }
      ],
      audioFeatures: {
        averageTempo: 95,
        averageDanceability: 0.75,
        averageEnergy: 0.68,
        averageValence: 0.6,
        dominantKey: 'F Minor',
        topGenres: ['Hip-Hop', 'Trap', 'Electronic'],
        moodProfile: {
          energetic: 0.75,
          happy: 0.6,
          chill: 0.4,
          melancholic: 0.25
        }
      }
    }
  },
  {
    userId: '6',
    name: 'Burna Boy',
    displayName: 'Burna Boy',
    bio: 'Multiple Grammy-winning Afrobeats artist with a unique blend of Afro-fusion, dancehall, and reggae. Looking to collaborate with international producers and vocalists.',
    role: 'Vocalist',
    location: 'Lagos, Nigeria',
    avatarUrl: 'https://media.gq.com/photos/5e5ebc2cb7235e00084122d3/16:9/w_2990,h_1682,c_limit/burna-boy-gq-style-spring-summer-2020-promo.jpg',
    genres: ['Afrobeats', 'Afro-fusion', 'Nigerian Pop'],
    socialLinks: { instagram: 'burnaboygram', spotify: 'burnaboy', youtube: 'burnaboy' },
    memberSince: new Date('2022-04-10'),
    totalReleases: 28,
    totalStreams: 950000,
    followers: 8520,
    following: 430,
    matchScore: {
      score: 87,
      factors: {
        genreOverlap: 75,
        roleCompatibility: 95,
        popularityMatch: 80,
        locationProximity: 60
      }
    }
  },
  {
    userId: '2',
    name: 'Sophia Chen',
    displayName: 'Sophia',
    bio: 'Singer-songwriter with a focus on indie folk and acoustic pop. Looking for producers to help finish my EP.',
    role: 'Vocalist',
    location: 'Portland, OR',
    avatarUrl: 'https://images.unsplash.com/photo-1601412436009-d964bd02edbc?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
    genres: ['Indie Folk', 'Acoustic', 'Pop'],
    socialLinks: { instagram: 'sophiamusic', spotify: 'sophiamusic' },
    memberSince: new Date('2023-03-22'),
    totalReleases: 5,
    totalStreams: 28000,
    followers: 310,
    following: 180,
    matchScore: {
      score: 85,
      factors: {
        genreOverlap: 80,
        roleCompatibility: 95,
        popularityMatch: 75,
        locationProximity: 70
      }
    }
  },
  {
    userId: '3',
    name: 'Marcus Johnson',
    displayName: 'MJ Drums',
    bio: 'Session drummer with 5+ years experience in jazz, rock, and R&B. Available for remote recording sessions and live performances.',
    role: 'Drummer',
    location: 'Chicago, IL',
    avatarUrl: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
    genres: ['Jazz', 'Rock', 'R&B'],
    socialLinks: { instagram: 'mjdrums', youtube: 'mjdrums' },
    memberSince: new Date('2022-09-10'),
    totalReleases: 8,
    totalStreams: 15000,
    followers: 210,
    following: 150,
    matchScore: {
      score: 78,
      factors: {
        genreOverlap: 60,
        roleCompatibility: 85,
        popularityMatch: 90,
        locationProximity: 65
      }
    }
  },
  {
    userId: '4',
    name: 'Layla Rodriguez',
    displayName: 'Layla',
    bio: 'Guitarist and songwriter influenced by alternative rock and indie. Looking to join a band or collaborate on songwriting.',
    role: 'Guitarist',
    location: 'Austin, TX',
    avatarUrl: 'https://images.unsplash.com/photo-1530785602389-07594beb8b73?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
    genres: ['Alternative Rock', 'Indie', 'Folk Rock'],
    socialLinks: { instagram: 'laylaplays', soundcloud: 'laylaplays' },
    memberSince: new Date('2023-05-05'),
    totalReleases: 3,
    totalStreams: 8000,
    followers: 180,
    following: 220,
    matchScore: {
      score: 88,
      factors: {
        genreOverlap: 85,
        roleCompatibility: 80,
        popularityMatch: 75,
        locationProximity: 90
      }
    }
  },
  {
    userId: '5',
    name: 'Daniel Kim',
    displayName: 'DK Beats',
    bio: 'Electronic music producer and DJ with focus on house and techno. Looking for vocalists for feature tracks.',
    role: 'Producer',
    location: 'Miami, FL',
    avatarUrl: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&auto=format&fit=crop&q=60&ixlib=rb-4.0.3',
    genres: ['House', 'Techno', 'Electronic'],
    socialLinks: { instagram: 'dkbeats', spotify: 'dkbeats', soundcloud: 'dkbeats' },
    memberSince: new Date('2022-11-18'),
    totalReleases: 15,
    totalStreams: 75000,
    followers: 820,
    following: 340,
    matchScore: {
      score: 75,
      factors: {
        genreOverlap: 65,
        roleCompatibility: 90,
        popularityMatch: 95,
        locationProximity: 60
      }
    }
  }
];

export const matchedProfiles = mockProfiles.slice(0, 2).map(profile => ({
  ...profile,
  matchedDate: new Date(Date.now() - Math.floor(Math.random() * 10 * 24 * 60 * 60 * 1000))
}));
